<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.qc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd">
          <div class="weui-form-preview__item" slot="qc_macode">
            <label class="weui-form-preview__label">{{customLabel.qc_macode || "工单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_macode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_ma_qty">
            <label class="weui-form-preview__label">{{customLabel.qc_ma_qty || "工单数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_ma_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_prodcode">
            <label class="weui-form-preview__label">{{customLabel.qc_prodcode || "物料编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_prodcode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_prodname">
            <label class="weui-form-preview__label">{{customLabel.qc_prodname || "物料名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_prodname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_custname">
            <label class="weui-form-preview__label">{{customLabel.qc_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_date">
            <label class="weui-form-preview__label">{{customLabel.qc_date || "日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.qc_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_wcname">
            <label class="weui-form-preview__label">{{customLabel.qc_wcname || "工作中心"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_wcname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_product_lines">
            <label class="weui-form-preview__label">{{customLabel.qc_product_lines || "线别"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_product_lines
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_work_class">
            <label class="weui-form-preview__label">{{customLabel.qc_work_class || "班次"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_work_class
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_person">
            <label class="weui-form-preview__label">{{customLabel.qc_person || "生产负责人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_person
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd">检验信息</div>
        <custom-layout class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item" slot="qc_qty">
            <label class="weui-form-preview__label">{{customLabel.qc_qty || "检验数量"}}</label>
            <span class="weui-form-preview__value">{{ form.main.qc_qty }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_ng_qty">
            <label class="weui-form-preview__label">{{customLabel.qc_ng_qty || "不良品数"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_ng_qty
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_ng_rate">
            <label class="weui-form-preview__label">{{customLabel.qc_ng_rate || "不良率"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_ng_rate
            }}%</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_ok_rate">
            <label class="weui-form-preview__label">{{customLabel.qc_ok_rate || "直通率目标"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.qc_ok_rate }}%</span
            >
          </div>
          <div class="weui-form-preview__item" slot="qc_ok">
            <label class="weui-form-preview__label">{{customLabel.qc_ok || "生产直通率"}}</label>
            <span class="weui-form-preview__value"
              >{{ 100 - form.main.qc_ng_rate }}%</span
            >
          </div>
          <div class="weui-form-preview__item" slot="qc_result">
            <label class="weui-form-preview__label">{{customLabel.qc_result || "检验判定"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_checker">
            <label class="weui-form-preview__label">{{customLabel.qc_checker || "检验员"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_checker
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_station">
            <label class="weui-form-preview__label">{{customLabel.qc_station || "QC位"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_station
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qc_remark">
            <label class="weui-form-preview__label">{{customLabel.qc_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.qc_remark
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.qd_detno }}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="qd_sn_code">
            <label class="weui-form-preview__label">{{customLabel.qd_sn_code || "S/N编号"}}</label>
            <span class="weui-form-preview__value">{{ item.qd_sn_code }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_date">
            <label class="weui-form-preview__label">{{customLabel.qd_date || "录入时间"}}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(item.qd_date,'yyyy-MM-dd')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_qty">
            <label class="weui-form-preview__label">{{customLabel.qd_qty || "数量"}}</label>
            <span class="weui-form-preview__value">{{ item.qd_qty }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_result">
            <label class="weui-form-preview__label">{{customLabel.qd_result || "检验结果"}}</label>
            <span class="weui-form-preview__value">{{ item.qd_result }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_ng_reason">
            <label class="weui-form-preview__label">{{customLabel.qd_ng_reason || "不良现象"}}</label>
            <span class="weui-form-preview__value">{{
              item.qd_ng_reason
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_judge">
            <label class="weui-form-preview__label">{{customLabel.qd_judge || "判定"}}</label>
            <span class="weui-form-preview__value">{{
              item.qd_judge
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="qd_remark">
            <label class="weui-form-preview__label">{{customLabel.qd_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{ item.qd_remark }}</span>
          </div>
           </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
   components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/qc/makeQc/",
      caller: "MakeQc",
      xtype: "qc-makeqc-formpanel",
    };
  },
};
</script>